module.exports = __webpack_public_path__ + "img/coupon-received-custom.e0ff2b80.png";